import React, { forwardRef } from "react";

import { Slot } from "@radix-ui/react-slot";
import styles from "../Styles/ui/Button.module.css";

const Button = forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    const variantClass = variant ? styles[`variant-${variant}`] : "";
    const sizeClass = size ? styles[`size-${size}`] : "";
    
    return (
      <Comp
        className={`${styles.button} ${variantClass} ${sizeClass} ${className}`}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button };